module.exports = __webpack_public_path__ + "media/svg/handshake-49d3ae35.svg";